import axios from "axios";
const dyrectApi = process.env.REACT_APP_DYRECT_API_URL;
export const createStripeAccount = async () => {
    try {
        const userId = localStorage.getItem('user_id');
        const path = "accounts";
        const response = await axios.post(dyrectApi + path, { userId });
        return response;
    } catch (error) {
        console.error("Error creating Stripe account:", error);
        throw error;
    }
};
export const makePayment = async (senderUserId, receiverUserId, amount) => {
    try {
        const path = "payments";
        const response = await axios.post(dyrectApi + path, { senderUserId, receiverUserId, amount });
        return response;
    } catch (error) {
        console.error("Error making payment:", error);
        throw error;
    }
}

export const getFraudReviewPayments = async (filter = 'all', search = '') => {
    try {
        const path = "fraud-review";
        const params = new URLSearchParams();
        
        if (filter && filter !== 'all') {
            params.append('filter', filter);
        }
        
        if (search) {
            params.append('search', search);
        }
        
        const queryString = params.toString();
        const url = queryString ? `${dyrectApi}${path}?${queryString}` : `${dyrectApi}${path}`;
        
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error("Error fetching fraud review payments:", error);
        throw error;
    }
}